import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43eaaf63"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_message_wrapper = _resolveComponent("message-wrapper")!

  return (_openBlock(), _createBlock(_component_message_wrapper, { class: "message-wrapper" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["align-items-center message-container echo", {
        'float-end': _ctx.message.isUserMessage(),
        'user-message': _ctx.message.isUserMessage()
      }])
      }, [
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.message.lines, (line, index) => {
            return (_openBlock(), _createElementBlock("p", {
              key: index,
              innerHTML: _ctx.getSafeHtml(line)
            }, null, 8, _hoisted_1))
          }), 128))
        ])
      ], 2),
      (!_ctx.waitingForBotResponse && _ctx.show)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reinput && _ctx.reinput(...args))),
            type: "button",
            title: "Edit value"
          }, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}